module.exports = __webpack_public_path__ + "static/cameron-logo-179fa24352df8d4e201b3a3a5ec54583.png";